<template>
    <li class="player-widget-item-container">
        <router-link
            :to="url"
            class="player-info"
        >
            <p class="player-name">
                {{ playerTitle }}
            </p>
            <p class="show-name">
                {{ showTitle }}
            </p>
        </router-link>
        <router-link
            class="functional-button"
            :to="`${url}&showEmbed=true`"
        >
            <i class="far fa-code" />
            <span>Embed Code</span>
        </router-link>
    </li>
</template>

<script>
export default {
    props: {
        url: {
            type: String,
            default: '',
        },
        showTitle: {
            type: String,
            default: '',
        },
        playerTitle: {
            type: String,
            default: '',
        },
    },
};
</script>
